import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type IGroupNode = {
  id: number;
  name: string;
  employerId: number;
  clientId: number;
};

type groupState = {
  list: IGroupNode[] | [];
};

const initialState: groupState = { list: [] };

const slice = createSlice({
  name: "groups",
  initialState,
  reducers: {
    setGroupsList(state, action: PayloadAction<groupState>) {
      state.list = action.payload.list ?? [];
    },
    clearGroups(state) {
      state.list = [];
    },
  },
});

export const { setGroupsList, clearGroups } = slice.actions;
export default slice.reducer;
